var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated-line-chart" },
    [
      _c("ECharts", {
        staticClass: "echart-graph",
        attrs: { option: _vm.getOptions() },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }